import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-feature-details-grid',
  templateUrl: './feature-details-grid.component.html',
  styleUrls: ['./feature-details-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureDetailsGridComponent {}
